import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../../config';

const CountDown = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [targetDate, setTargetDate] = useState(null);

  useEffect(() => {
    const fetchTargetDate = async () => {
      try {
        const response = await axios.get(
          `https://htstaging-uau5g.ondigitalocean.app/tables/nearest-no-host`
        );
        const eventDate = response.data.event_date; // Format: "22-12-2025 11:00"
        const [date, time] = eventDate.split(' ');
        const [day, month, year] = date.split('-').map(Number);
        const [hours, minutes] = time.split(':').map(Number);
        setTargetDate(new Date(year, month - 1, day, hours, minutes, 0, 0));
      } catch (error) {
        console.error('Error fetching target date:', error);
      }
    };

    fetchTargetDate();
  }, []);

  useEffect(() => {
    if (!targetDate) return;

    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const seconds = Math.floor(difference / 1000) % 60;
      const minutes = Math.floor(difference / 1000 / 60) % 60;
      const hours = Math.floor(difference / 1000 / 60 / 60) % 24;
      const days = Math.floor(difference / 1000 / 60 / 60 / 24);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    // run immediately so UI doesn't wait 1s for first tick
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div
      data-w-id="37c595d2-61a3-9933-2240-cb13e572d413"
      style={{ opacity: 0 }}
      className="countdown-row"
    >
      <div className="countdown-block">
        <div id="days" className="countdown-time">
          {String(timeLeft.days).padStart(2, '0')}
        </div>
        <div className="countdown-detail">Days</div>
      </div>
      <div className="countdown-block">
        <div id="hours" className="countdown-time">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <div className="countdown-detail">Hours</div>
      </div>
      <div className="countdown-block">
        <div id="minutes" className="countdown-time">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <div className="countdown-detail">Minutes</div>
      </div>
      <div className="countdown-block">
        <div id="seconds" className="countdown-time">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <div className="countdown-detail">Seconds</div>
      </div>
    </div>
  );
};

export default CountDown;
